export default __webpack_public_path__ + "static/media/captain.832c0d8e.png";